var _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrainPumpOffCondenserOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Untitled-1-02",
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 111,
    viewBox: "0 0 75 111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9847",
    "data-name": "Group 9847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9833",
    "data-name": "Group 9833"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4310",
    "data-name": "Rectangle 4310",
    width: 39.17,
    height: 5.2,
    transform: "translate(0 46.02)",
    fill: "#6a7084"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9846",
    "data-name": "Group 9846"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9834",
    "data-name": "Group 9834"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4311",
    "data-name": "Rectangle 4311",
    width: 20.85,
    height: 36.74,
    transform: "translate(48.61 27.92)",
    fill: "#6a7084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3872",
    "data-name": "Path 3872",
    d: "M69.6,64.8H48.48V27.79H69.6Zm-20.85-.27H69.34V28.06H48.75Z",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9835",
    "data-name": "Group 9835"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_348",
    "data-name": "Ellipse 348",
    cx: 27.61,
    cy: 27.79,
    rx: 27.61,
    ry: 27.79,
    transform: "translate(14.25 0.13)",
    fill: "#6a7084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3873",
    "data-name": "Path 3873",
    d: "M41.86,55.84A27.921,27.921,0,1,1,69.6,27.92,27.871,27.871,0,0,1,41.86,55.84Zm0-55.57A27.651,27.651,0,1,0,69.34,27.92,27.6,27.6,0,0,0,41.86.27Z",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9836",
    "data-name": "Group 9836"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4312",
    "data-name": "Rectangle 4312",
    width: 31.65,
    height: 7.47,
    transform: "translate(43.22 64.67)",
    fill: "#6a7084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3874",
    "data-name": "Path 3874",
    d: "M75,72.27H43.08V64.54H75ZM43.35,72H74.73V64.8H43.35Z",
    fill: "#231f20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9837",
    "data-name": "Group 9837"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3875",
    "data-name": "Path 3875",
    d: "M38.17,17.34a10.47,10.47,0,0,1,5.77-.5,13.035,13.035,0,0,0-2.47-4.35,16.193,16.193,0,0,0-7.01,1.91A13.024,13.024,0,0,1,38.17,17.34Z",
    fill: "#8b90a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9838",
    "data-name": "Group 9838"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3876",
    "data-name": "Path 3876",
    d: "M31.97,22.92a10.647,10.647,0,0,1,3.73-4.46,12.812,12.812,0,0,0-4.81-1.32,16.444,16.444,0,0,0-3.61,6.33A13.239,13.239,0,0,1,31.97,22.92Z",
    fill: "#8b90a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9839",
    "data-name": "Group 9839"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3877",
    "data-name": "Path 3877",
    d: "M31.49,31.5A10.691,10.691,0,0,1,31,25.69a12.93,12.93,0,0,0-4.33,2.49,16.439,16.439,0,0,0,1.9,7.05A13.4,13.4,0,0,1,31.49,31.5Z",
    fill: "#8b90a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9840",
    "data-name": "Group 9840"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3878",
    "data-name": "Path 3878",
    d: "M52.22,24.24a10.691,10.691,0,0,1,.49,5.81,12.93,12.93,0,0,0,4.33-2.49,16.439,16.439,0,0,0-1.9-7.05A13.4,13.4,0,0,1,52.22,24.24Z",
    fill: "#8b90a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9841",
    "data-name": "Group 9841"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3879",
    "data-name": "Path 3879",
    d: "M46.53,17.83a10.584,10.584,0,0,1,4.43,3.75,13.035,13.035,0,0,0,1.31-4.84,16.3,16.3,0,0,0-6.29-3.64A13.994,13.994,0,0,1,46.53,17.83Z",
    fill: "#8b90a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9842",
    "data-name": "Group 9842"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3880",
    "data-name": "Path 3880",
    d: "M37.13,38.04a10.584,10.584,0,0,1-4.43-3.75,13.035,13.035,0,0,0-1.31,4.84,16.3,16.3,0,0,0,6.29,3.64A13.73,13.73,0,0,1,37.13,38.04Z",
    fill: "#8b90a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9843",
    "data-name": "Group 9843"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3881",
    "data-name": "Path 3881",
    d: "M45.43,38.51a10.47,10.47,0,0,1-5.77.5,13.035,13.035,0,0,0,2.47,4.35,16.193,16.193,0,0,0,7.01-1.91A13.423,13.423,0,0,1,45.43,38.51Z",
    fill: "#8b90a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9844",
    "data-name": "Group 9844"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3882",
    "data-name": "Path 3882",
    d: "M51.8,32.78a10.647,10.647,0,0,1-3.73,4.46,12.812,12.812,0,0,0,4.81,1.32,16.444,16.444,0,0,0,3.61-6.33A13.7,13.7,0,0,1,51.8,32.78Z",
    fill: "#8b90a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9845",
    "data-name": "Group 9845"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_349",
    "data-name": "Ellipse 349",
    cx: 6.31,
    cy: 6.35,
    rx: 6.31,
    ry: 6.35,
    transform: "translate(35.55 21.57)",
    fill: "#8b90a0"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4313",
    "data-name": "Rectangle 4313",
    width: 75,
    height: 111,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrainPumpOffCondenserOff);
export default __webpack_public_path__ + "static/media/drain_pump_off_condenser_off.df5927d023b9db8f7fbf898c37d7f59f.svg";
export { ForwardRef as ReactComponent };